module.exports = __webpack_public_path__ + "img/phase2-2014-03.a4d9ae2a.jpg";